// Web Awesome custom-element registration - shared by the app (main.ts) and Storybook
// (.storybook/preview.ts) so the catalog renders wa-* elements exactly like the running app.
// Importing this module has the side effect of registering the custom elements below.
//
// NOTE: this file must stay JS-only (no CSS imports). Storybook compiles preview.ts with
// webpack, which has no raw-CSS loader. Global stylesheets are loaded separately: via
// angular.json `styles` for the app, and the Storybook builder `styles` option for the catalog.

// - Components
import '@web.awesome.me/webawesome-pro/dist/components/spinner/spinner.js';
import '@web.awesome.me/webawesome-pro/dist/components/divider/divider.js';
import '@web.awesome.me/webawesome-pro/dist/components/scroller/scroller.js';
import '@web.awesome.me/webawesome-pro/dist/components/button/button.js';
import '@web.awesome.me/webawesome-pro/dist/components/button-group/button-group.js';
import '@web.awesome.me/webawesome-pro/dist/components/progress-bar/progress-bar.js';
import '@web.awesome.me/webawesome-pro/dist/components/relative-time/relative-time.js';
import '@web.awesome.me/webawesome-pro/dist/components/input/input.js';
import '@web.awesome.me/webawesome-pro/dist/components/card/card.js';
import '@web.awesome.me/webawesome-pro/dist/components/textarea/textarea.js';
import '@web.awesome.me/webawesome-pro/dist/components/badge/badge.js';
import '@web.awesome.me/webawesome-pro/dist/components/tooltip/tooltip.js';
import '@web.awesome.me/webawesome-pro/dist/components/avatar/avatar.js';
import '@web.awesome.me/webawesome-pro/dist/components/icon/icon.js';
import '@web.awesome.me/webawesome-pro/dist/components/popup/popup.js';
import '@web.awesome.me/webawesome-pro/dist/components/popover/popover.js';
import '@web.awesome.me/webawesome-pro/dist/components/drawer/drawer.js';
import '@web.awesome.me/webawesome-pro/dist/components/combobox/combobox.js';
import '@web.awesome.me/webawesome-pro/dist/components/select/select.js';
import '@web.awesome.me/webawesome-pro/dist/components/option/option.js';
import '@web.awesome.me/webawesome-pro/dist/components/tag/tag.js';
import '@web.awesome.me/webawesome-pro/dist/components/carousel/carousel.js';
import '@web.awesome.me/webawesome-pro/dist/components/carousel-item/carousel-item.js';
import '@web.awesome.me/webawesome-pro/dist/components/copy-button/copy-button.js';
import '@web.awesome.me/webawesome-pro/dist/components/radio/radio.js';
import '@web.awesome.me/webawesome-pro/dist/components/radio-group/radio-group.js';
import '@web.awesome.me/webawesome-pro/dist/components/tab-group/tab-group.js';
import '@web.awesome.me/webawesome-pro/dist/components/tab-panel/tab-panel.js';
import '@web.awesome.me/webawesome-pro/dist/components/callout/callout.js';
import '@web.awesome.me/webawesome-pro/dist/components/tab/tab.js';
import '@web.awesome.me/webawesome-pro/dist/components/skeleton/skeleton.js';
import '@web.awesome.me/webawesome-pro/dist/components/dialog/dialog.js';
import '@web.awesome.me/webawesome-pro/dist/components/dropdown/dropdown.js';
import '@web.awesome.me/webawesome-pro/dist/components/dropdown-item/dropdown-item.js';
import '@web.awesome.me/webawesome-pro/dist/components/checkbox/checkbox.js';
import '@web.awesome.me/webawesome-pro/dist/components/switch/switch.js';
import '@web.awesome.me/webawesome-pro/dist/components/toast/toast.js';
import '@web.awesome.me/webawesome-pro/dist/components/toast-item/toast-item.js';

import { setBasePath, setKitCode } from '@web.awesome.me/webawesome-pro/dist/utilities/base-path.js';

setBasePath('/assets/webawesome');

// Kit code for FONT awesome
setKitCode('90dd5bdb2f');
